import { Component, EventEmitter, Input, OnInit, Output, inject } from '@angular/core'
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms'
import { FilterComponent } from 'src/app/shared/components/base/filter/filter.component'
import { InputComponent } from 'src/app/shared/components/form-elements/input/input.component'
import { SwitchComponent } from 'src/app/shared/components/form-elements/switch/switch.component'
import { StaffFilter } from 'src/app/shared/interfaces/staff/staff-filter.interface'

@Component({
    selector: 'sf-staff-search',
    imports: [ReactiveFormsModule, FilterComponent, InputComponent, SwitchComponent],
    templateUrl: './staff-search.component.html',
    styleUrls: ['./staff-search.component.scss']
})
export class StaffSearchComponent implements OnInit {
    private fb = inject(FormBuilder)

    form: FormGroup = this.fb.group({
        searchTerm: [''],
        isDeleted: [false],
    })

    @Input() initialFilter!: StaffFilter

    @Output() searched = new EventEmitter<StaffFilter>()

    ngOnInit(): void {
        this.form.patchValue(this.initialFilter)
    }

    search(): void {
        this.searched.emit(this.form.value)
    }

    reset(): void {
        this.form.reset()
        this.searched.emit(this.form.value)
    }
}
